import { IMG } from "../data/images";
import { Reveal, Overline, OrnamentDivider } from "./Reveal";
import { useLang } from "../i18n";

export const Story = () => {
    const { t } = useLang();
    return (
    <section id="story" data-testid="our-story-section" className="relative py-24 sm:py-32 lg:py-40 overflow-hidden">
        <div
            className="absolute right-0 top-1/3 font-cinzel text-[26vw] leading-none text-brass/[0.04] select-none pointer-events-none"
            aria-hidden="true"
        >
            तड़का
        </div>
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
            <Reveal className="order-2 lg:order-1">
                <Overline>{t("story.overline")}</Overline>
                <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl text-cream leading-[1.05] text-balance">
                    {t("story.h1a")} <span className="italic gold-text">{t("story.h1b")}</span>
                </h2>
                <OrnamentDivider className="mt-6 justify-start" />
                <div className="mt-6 space-y-5 text-stone-300 font-light leading-relaxed max-w-xl">
                    <p>
                        {t("story.p1")}
                    </p>
                    <p>
                        {t("story.p2")}
                    </p>
                    <p>
                        {t("story.p3")}
                    </p>
                </div>
            </Reveal>

            <Reveal delay={0.15} className="order-1 lg:order-2">
                <div className="relative">
                    <div className="rounded-3xl overflow-hidden aspect-[4/5] max-w-md ml-auto group">
                        <img
                            src={IMG.tandoori}
                            alt="Tandoori dishes from the clay oven"
                            loading="lazy"
                            className="w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-ink/50 to-transparent" />
                    </div>
                    <div className="absolute -bottom-10 -left-2 sm:left-0 w-44 sm:w-56 rounded-2xl overflow-hidden gold-border shadow-2xl shadow-black/60">
                        <img
                            src={IMG.samosa}
                            alt="Fresh Indian starters"
                            loading="lazy"
                            className="w-full aspect-[4/3] object-cover"
                        />
                    </div>
                    <div className="absolute -top-5 -left-2 sm:-left-5 gold-border rounded-full px-5 py-2.5 bg-ink/80 backdrop-blur">
                        <span className="font-cinzel text-xs tracking-[0.3em] text-brass">{t("story.badge")}</span>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);
};

